export const CHECKOUT_URL =
  'https://pro-braid-gloss-academy.impultienda.ar/checkout'

export const product = {
  name: 'THE BRAID & GLOSS BIBLE™',
  headline: 'Start charging for braids and keratin in less than 30 days.',
  subheadline:
    'The definitive set of 6 volumes plus 5 strategic bonuses — every technique protocol, price list and client tool you need, already prepared for you in printable PDF.',
  price: '$27',
  compareAt: '$707',
  savings: 'YOU SAVE $680 — 96% DISCOUNT',
  email: 'hello@braidandglossbible.com',
}

export const mockupImage =
  'https://cdn.magicpatterns.com/uploads/gQpYFMZaond16HR4MTYX8v/ChatGPT_Image_31_ago_2026,_04_22_20_p.m..png'

export const braidingImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/d4e39e4f-6812-4833-8684-786f5dba30b1.jpg'

export const heroChips: string[] = [
  '6 COMPLETE VOLUMES',
  '5 STRATEGIC BONUSES',
  'ALL HAIR TYPES & TEXTURES',
  '100% PDF · INSTANT DOWNLOAD',
  'LIFETIME ACCESS',
]

export const trustBadges: string[] = [
  'Secure payment',
  'Instant access',
  '7-day guarantee',
]

export interface Stat {
  value: string
  label: string
}

export const stats: Stat[] = [
  { value: '5,000+', label: 'Stylists across USA, UK, Canada & Australia' },
  { value: '6 + 5', label: 'Volumes and bonuses included' },
  { value: '4.9/5', label: 'Community rating' },
  { value: '$80–$250', label: 'Average price per service taught' },
]

export interface Quote {
  text: string
  name: string
  role: string
  city: string
}

export const quickQuotes: Quote[] = [
  {
    text: 'I booked my first three paying clients the same week I finished Volume 02. I had never braided for money before.',
    name: 'Sarah M.',
    role: 'Home-based stylist',
    city: 'Miami',
  },
  {
    text: 'I stopped guessing with keratin. The protocol tells me exactly which product goes on which hair type and why.',
    name: 'Jessica R.',
    role: 'Mobile stylist',
    city: 'London',
  },
  {
    text: 'The pricing chapter alone doubled what I charge. Same hours, twice the income, zero extra stress.',
    name: 'Danielle P.',
    role: 'Salon suite owner',
    city: 'Toronto',
  },
]

export const problems: string[] = [
  'You spend hours on YouTube stitching together tutorials that contradict each other',
  'Your braids slip, frizz or hurt your client and you cannot explain why',
  'You are terrified of burning hair or scalp with a chemical treatment',
  'You have no idea what to charge, so you undercharge and resent the work',
  'Clients book once and never come back because there is no plan for their hair',
  'You are trading every free evening for a paycheck that barely covers the bills',
]

export const productMetrics: Stat[] = [
  { value: '240+', label: 'PRACTICAL PAGES' },
  { value: '6', label: 'COMPLETE VOLUMES' },
  { value: '5', label: 'STRATEGIC BONUSES' },
  { value: '11', label: 'PDF FILES' },
]

export interface CoverageItem {
  number: string
  label: string
}

export const coverage: CoverageItem[] = [
  { number: '01', label: 'Sectioning & Tension Foundations' },
  { number: '02', label: 'Box Braids & Knotless' },
  { number: '03', label: 'Cornrows & Feed-ins' },
  { number: '04', label: 'Mirror-Effect Keratin' },
  { number: '05', label: 'Straightening & Finishing' },
  { number: '06', label: 'Pricing, Booking & Retention' },
]

export interface Volume {
  number: string
  title: string
  description: string
  tags: string[]
}

export const volumes: Volume[] = [
  {
    number: '01',
    title: 'The Foundations Method',
    description:
      'The framework behind the whole system: how to read a head of hair, section it cleanly, and control tension so nothing slips or breaks.',
    tags: ['Hair Analysis', 'Sectioning', 'Controlled Tension', 'Tool Kit'],
  },
  {
    number: '02',
    title: 'Box Braids & Knotless Mastery',
    description:
      '50 complete services covering parting patterns, extension prep, feeding technique and sealing — with timing benchmarks for each length.',
    tags: ['Parting Grids', 'Knotless Starts', 'Feeding', 'Sealing'],
  },
  {
    number: '03',
    title: 'Cornrows & Feed-in Mastery',
    description:
      'Finger placement, direction mapping and pattern design broken down frame by frame so straight-backs and freestyle parts come out clean.',
    tags: ['Finger Placement', 'Pattern Design', 'Edges', 'Freestyle Parts'],
  },
  {
    number: '04',
    title: 'The Mirror-Effect Keratin Protocol',
    description:
      'The chemistry of smoothing treatments: pH, actives, processing times and cuticle sealing — mapped to every hair type and porosity level.',
    tags: ['pH & Actives', 'Porosity Map', 'Processing Times', 'Cuticle Seal'],
  },
  {
    number: '05',
    title: 'Straightening, Sealing & Finishing',
    description:
      'Heat protocols, tension pass technique and finishing products that hold a mirror shine for months instead of days.',
    tags: ['Heat Control', 'Tension Pass', 'Shine Finish', 'Aftercare'],
  },
  {
    number: '06',
    title: 'The $500/Week Business Blueprint',
    description:
      'Everything after the technique: pricing your menu, filling your calendar, handling deposits and turning first-timers into standing appointments.',
    tags: ['Service Menu', 'Pricing', 'Deposits', 'Retention'],
  },
]

export interface Bonus {
  number: string
  value: string
  title: string
  description: string
  cover: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    value: '$67',
    title: "The Stylist's Secret Vendor List",
    description:
      'Wholesale access to the hair, extensions and treatment suppliers professionals actually order from — with what to buy first.',
    cover:
      'https://cdn.magicpatterns.com/uploads/x9qKFXXj9gyW3QNUe9rjpJ/img_trenza_5.webp',
  },
  {
    number: '02',
    value: '$97',
    title: 'The 7-Day Social Media Launchpad',
    description:
      'A day-by-day posting plan, caption templates and before/after shot list that turns your phone into a booking machine.',
    cover:
      'https://cdn.magicpatterns.com/uploads/gQTVKX3ER3Co1hFQ1W973B/img_trenza_4.webp',
  },
  {
    number: '03',
    value: '$47',
    title: 'Quick Reference: Braiding Tension & Parting Guide',
    description:
      'The tension and parting cheat sheet you keep beside you at the chair — clean grids, safe pull, no slipping and no sore scalps.',
    cover:
      'https://cdn.magicpatterns.com/uploads/7gdoGRysHgktZ9fiuatE3j/img_1_trenza.webp',
  },
  {
    number: '04',
    value: '$57',
    title: 'Mirror-Effect Styling Protocol Checklist',
    description:
      'Prepare, protect, smooth, shine, seal, maintain — the full smoothing service as a tick-box checklist so nothing gets skipped.',
    cover:
      'https://cdn.magicpatterns.com/uploads/5VgVvPe649qg3rnjxxpsnV/img_trenza_2.webp',
  },
  {
    number: '05',
    value: '$37',
    title: 'Client Consultation Script & Product Selection Worksheet',
    description:
      'What to ask, what to write down and which product to choose — printable sheets that make you look like a salon from day one.',
    cover:
      'https://cdn.magicpatterns.com/uploads/3URxTVLFr2CsGKtGd3qt7Y/img_trenza_3.webp',
  },
]

export const included: string[] = [
  '6 complete technique volumes',
  '5 strategic bonuses',
  'Printable PDF — no videos, no audiobooks',
  'Every hair type and texture',
  'Pricing, booking and consultation tools',
  'Lifetime access to all materials',
]

export interface Review {
  initials: string
  name: string
  role: string
  city: string
  text: string
  featured?: boolean
}

export const reviews: Review[] = [
  {
    initials: 'SM',
    name: 'Sarah M.',
    role: 'Home-based stylist',
    city: 'Miami',
    text: 'I was terrified of doing keratin on someone else. After the Mirror-Effect volume I did my first service on a neighbour and charged $80. She loved it. The book paid for itself in 48 hours.',
    featured: true,
  },
  {
    initials: 'JR',
    name: 'Jessica R.',
    role: 'Mobile stylist',
    city: 'London',
    text: 'YouTube taught me how to braid. This taught me how to get clients from Instagram. I have four bookings for next weekend already.',
  },
  {
    initials: 'DP',
    name: 'Danielle P.',
    role: 'Salon suite owner',
    city: 'Toronto',
    text: 'The parting grids alone cut an hour off my box braid time. Faster services, same price, happier clients.',
  },
  {
    initials: 'AK',
    name: 'Amara K.',
    role: 'Part-time stylist',
    city: 'Sydney',
    text: 'The consultation forms made me look professional from day one. Clients treat me differently now, and they rebook.',
  },
  {
    initials: 'LT',
    name: 'Leah T.',
    role: 'Beginner',
    city: 'Manchester',
    text: 'I had never held a flat iron properly. Six weeks later I am charging for smoothing services out of my kitchen.',
  },
]

export const guaranteeBadges: string[] = [
  'SIMPLE REFUND',
  'NO FORMS TO FILL',
  'KEEP ALL BONUSES',
]

export const formatPoints: string[] = [
  'Every volume and bonus is a PDF document',
  'No video lessons, no audiobooks, nothing to stream',
  'Print any page or keep it on your phone at the chair',
  'Download instantly after checkout',
]

export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: 'Is this digital or physical?',
    answer:
      'Completely digital. All the content is PDF — there are no videos for now. Instant access, and you can print anything you want.',
  },
  {
    question: 'Will this work on my hair type?',
    answer:
      'Yes. Every protocol is mapped across textures and porosity levels, from fine straight hair to 4C coils, with the adjustments spelled out for each.',
  },
  {
    question: 'Do I need professional tools to start?',
    answer:
      'No. We show you how to start with basic tools you likely already own, and exactly what to upgrade first once your first profits come in.',
  },
  {
    question: 'Is this for absolute beginners?',
    answer:
      'Yes. We start from finger placement and sectioning, and the volumes are sequenced so each one builds on the last.',
  },
  {
    question: 'What if I am not completely satisfied?',
    answer:
      'Email us within 7 days and we refund every penny. You keep all five bonuses. No forms, no questions.',
  },
]

export interface ComparisonRow {
  before: string
  after: string
}

export const comparison: ComparisonRow[] = [
  {
    before: 'Hours lost stitching together free tutorials',
    after: 'One system, sequenced volume by volume',
  },
  {
    before: 'Braids that slip, frizz or hurt',
    after: 'Controlled tension, clean parts, every time',
  },
  {
    before: 'Guessing with chemicals and hoping',
    after: 'A pH and porosity protocol you can trust',
  },
  {
    before: 'Undercharging because you feel unqualified',
    after: 'A priced service menu and booking scripts',
  },
  {
    before: 'Clients who never come back',
    after: 'Consultation, aftercare and rebooking built in',
  },
]
